$(() => {
    $('#aocFileInput').on('change',
        (e) => {
            renderFiles('aocFileInput', 'aocNumberFiles', 'fileList');
        });
});

const renderFiles = (fileInputName, fileListInputName, outputName) => {
    const fileInput = document.getElementById(fileInputName);
    const fileListInput = document.getElementById(fileListInputName);
    const output = document.getElementById(outputName);
    const files = getFiles(fileInput);
    const newFiles = getFiles(fileListInput);

    files.push(...newFiles);
    setFiles(fileListInput, files)
    output.innerHTML = '<ul>';

    for (var i = 0; i < fileListInput.files.length; ++i) {
        output.innerHTML += '<li>' + fileListInput.files.item(i).name + '</li>';
    }
    output.innerHTML += '</ul>';
}
const getFiles = (input) => {
    const files = new Array(input.files.length);

    for (let i = 0; i < input.files.length; i++) {
        files[i] = input.files.item(i);
    }
    return files;
}

const setFiles = (input, files) => {
    const dataTransfer = new DataTransfer();
    for (const file of files) {
        dataTransfer.items.add(file);
    }

    input.files = dataTransfer.files;
}